module.exports = __webpack_public_path__ + "img/banner2.b76b55f5.png";